/**
 * SPA entry point.
 *
 * Assistant is a Hebrew-first face with a clear grid at small sizes. It was
 * already being downloaded here — but `--font-sans`, the variable every
 * stylesheet referenced it through, was never actually defined anywhere, so
 * the whole app silently fell back to the system UI font and none of these
 * four files were ever used. tokens.css defines it now.
 *
 * Stylesheet order is load-bearing: globals.css is the legacy sheet (it still
 * carries Tailwind's preflight and the not-yet-rebuilt screens), and the new
 * layers come after it so they win where the two overlap. It shrinks with each
 * screen that moves onto the kit, and goes away with the last of them.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@fontsource/assistant/400.css";
import "@fontsource/assistant/500.css";
import "@fontsource/assistant/600.css";
import "@fontsource/assistant/700.css";
import "@fontsource/assistant/800.css";
import "@/styles/globals.css";
import "@/styles/tokens.css";
import "@/styles/base.css";
import "@/styles/kit.css";
import "@/styles/shell.css";
import "@/styles/map.css";
import "@/styles/screens.css";
import App from "@/App";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
